export class StreamUploader {
  constructor(options) {
    this.mainRecorder = null

    //store recorded chucks
    this.mainChunk = []

    this.options = options
    this.serverUrl = options.serverUrl
  }

  // Initialize the recorders
  init() {
    this.mainRecorder = this.createRecorder([
      ...this.options.videoStream.getTracks(),
      ...this.options.audioStream.getTracks(),
      // ...this.options.screenStream.getTracks(),
    ])
  }

  createRecorder(stream) {
    const combinedStream = new MediaStream(stream)
    const recorder = new MediaRecorder(combinedStream)

    recorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.mainChunk.push(event.data)
        // this.sendDataToServer(event.data, type)
        if (this.options.onDataAvailable) {
          this.options.onDataAvailable(event.data)
        }
      }
    }

    return recorder
  }

  // Start recording video, audio, and screen streams
  start() {
    if (this.mainRecorder) {
      console.log('Recorder started **********************************')
      this.mainRecorder.start()
    } else {
      console.error('Recorders are not initialized.')
    }
  }

  stop() {
    console.log('Stoping srtream')
    if (!this.mainRecorder) {
      console.log('main recorder does not exists')

      return Promise.reject(new Error('Recorder not initialized'))
    }

    return new Promise((resolve) => {
      this.mainRecorder.onstop = () => {
        console.log('should stop streams', this.mainChunk)

        const blob = new Blob(this.mainChunk, { type: 'video/webm' })
        console.log('should stop streams', blob)
        resolve(blob)
      }

      console.log('Stoping srtream initializer', this.mainRecorder)

      this.mainRecorder.stop()
    })
  }

  // Send the recorded data chunk to the server for storage
  sendDataToServer(data, type) {
    const formData = new FormData()
    formData.append('file', data, `${type}-${Date.now()}.webm`)
    formData.append('type', type)

    fetch(this.serverUrl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          console.error('Failed to upload data chunk:', response.statusText)
        }
      })
      .catch((error) => {
        // console.error('Error uploading data:', error)
      })
  }

  uploadBlob(chunks, type) {
    if (!chunks.length) return

    console.log('Uploading Boob')

    const blob = new Blob(chunks, { type: 'video/webm' })
    return blob
  }
}
